import React, { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import AuthService from 'core/utils/auth/auth-service';

class HeaderUserSettings extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {
      profile: AuthService.getProfile(),
      isOpen: false,
    };
  }

  toggle = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  logout = (e) => {
    e.preventDefault();
    AuthService.logout();
  }

  render() {
    return (
      <div className="HeaderUserSettings">
        <Dropdown
          isOpen={this.state.isOpen}
          toggle={this.toggle}
        >
          <DropdownToggle
            href="true"
            tag="a"
            className="HeaderUserSettings__link"
          >
            <FontAwesomeIcon
              icon={["fal", "cog"]}
            />
          </DropdownToggle>
          <DropdownMenu
            className="HeaderUserSettings__subMenu"
            right
          >
            <div onClick={this.toggle}>
              <Link
                to="/account"
                className="dropdown-item"
              >
                Account Settings
              </Link>
              <div className="dropdown-divider"></div>
              <a
                to="/logout"
                className="dropdown-item"
                onClick={e => this.logout(e)}
              >
                Logout
              </a>
            </div>
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

export default HeaderUserSettings;



// WEBPACK FOOTER //
// ./src/components/layouts/LoggedIn/Header/HeaderUserSettings.js